<script lang="ts">
  import Modal from "$app/components/Modal.svelte"
  import { xhr, toast, wait } from "$app/utils"

  let showDeleteModal = $state(false)
  let delText = $state("")

  async function deleteAccount() {
    if (
      confirm(
        "Are you sure you want to delete your account?\nAll your data will be deleted!"
      )
    ) {
      try {
        const resp = await xhr.delete("/users/delete_account")
        if (resp.data.success) {
          toast("You have successfully deleted your account", "success")
          await wait(3000)
          const newWindow = window as Window
          newWindow.location = "/users/sign_out"
        } else {
          throw "Error deleting account"
        }
      } catch (e) {
        toast("There was an error deleting your account", "error")
      }
    }
  }
</script>

<p class="mt-1 max-w-2xl text-xl text-gray-700">
  Permanently Delete Your Account
</p>
<p class="mt-4 max-w-2xl text-base text-gray-500">
  When you delete your Lead With Purpose account, your data is permanently
  deleted and cannot be retrieved. Also note that any Plans that you are the
  Owner of will also be deleted along with ALL plan data. <span
    class="font-bold"
    >This operation is irreverable so please use with caution.</span
  >
</p>
<div class="p-8 text-center">
  <button
    class="btn danger btn-big btn-rounded mt-2"
    onclick={() => (showDeleteModal = true)}
    type="button"
  >
    Permanently Delete Account
  </button>
</div>
<Modal
  open={showDeleteModal}
  style="max-width: 350px !important;"
  onclose={() => {
    delText = ""
    showDeleteModal = false
  }}
>
  <div class="text-center p-4">
    Please type DELETE to enable the
    <span class="font-semibold">Permanently Delete Account</span>
    button
    <div class="input-cont">
      <input
        type="text"
        class="input w-12 font-semibold text-center"
        bind:value={delText}
      />
    </div>

    <button
      class="btn danger btn-big btn-rounded mt-2"
      onclick={deleteAccount}
      disabled={delText !== "DELETE"}
      type="button"
    >
      Permanently Delete Account
    </button>
  </div>
</Modal>
